import { defineComponent } from 'vue';
var dataSwiper1 = [
    {
        imgSrc: '/images/top/contents/slide1/img1.jpg',
        subTitle: 'プログラム',
        title: 'レゴⓇブロックのミニキットプレゼント',
        content: 'レゴジャパン公式LINEのお友だち追加とクイズへの回答で手軽に楽しめるレゴⓇミニキットを配布します。',
        table: [
            {
                開催日時: '2025年11月29日(土)・11月30日(日)、12月6日(土)・7日(日)、20日(土)・21日(日)　いずれも11時から17時'
            },
            {
                対象年齢: '小学生以下'
            },
            {
                参加方法: '会場内に設置されたレゴⓇブロック製品モデルに関連するクイズに答え、レゴジャパン公式LINEのお友だち追加の上、Kids Area内引き換えブースでクイズの答えをお伝えいただいた方にレゴⓇミニキットをお渡しします。'
            }
        ],
        note: '※ミニキットは先着順でのお渡しで、数に限りがございます。'
    },
    {
        imgSrc: '/images/top/contents/slide1/img2.jpg',
        subTitle: 'プログラム',
        title: 'レゴⓇブロックセーラーくんグリーティング​',
        content: '開港の地である関内エリアにセーラーくんが登場します。',
        table: [
            {
                開催日時: '2025年11月29日(土)・11月30日(日)'
            }
        ],
        note: '※登場する時間や場所は11月中旬に発表予定です。'
    },
    {
        imgSrc: '/images/top/contents/slide1/img3.jpg',
        subTitle: 'プログラム',
        title: 'レゴⓇクリスマスツリー',
        content: ['3万個のレゴⓇブロックを使ってみんなで大きなクリスマスツリーを作ろう！', '作られたクリスマスツリーは2025年12月25日(木)までKids Areaにて展示予定です'],
        table: [
            {
                開催日時: '2025年11月29日(土)・11月30日(日)　11時から17時'
            },
            {
                開催場所: 'Kids Area'
            },
            {
                対象年齢: '4歳以上'
            },
            {
                参加方法: '先着順'
            }
        ],
        note: ['※上記内容は予告なく当日変更となる場合がございます。予めご了承ください。​​', '※未就学児のお子さまが参加される際は、必ず保護者同伴でのご参加をお願いいたします​。']
    },
    {
        imgSrc: '/images/top/contents/slide1/img4.jpg',
        subTitle: 'プログラム',
        title: 'レゴⓇブロックフォトスポット',
        content: '会場内に4か所、レゴⓇブロックで作られた忍者やかわいいうさぎなどをモチーフにした3Dモデルのフォトスポットが登場します。',
        table: [
            {
                展示期間: '2025年11月29日(土)～2025年12月25日(木)　11時から17時'
            }
        ],
        note: '※画像はイメージです。今回はグラウンド外での展示を予定しています。'
    },
    {
        imgSrc: '/images/top/contents/slide1/img5.jpg',
        subTitle: 'プログラム',
        title: 'レゴⓇブロックプレイグラウンド！',
        content: 'Kids Areaの一部に、レゴⓇブロック、レゴⓇデュプロⓇブロックを自由に楽しめるエリアが登場します。',
        table: [
            {
                開催日時: '2025年11月29日(土)～2025年12月25日(木)　11時から17時'
            },
            {
                開催場所: 'Kids Area'
            },
            {
                対象年齢: 'レゴⓇブロック（４歳以上）/レゴⓇデュプロⓇブロック（1.5歳以上）'
            }
        ],
        note: '※未就学児のお子さまが参加される際は、必ず保護者同伴でのご参加をお願いいたします​。'
    }
];
var dataSwiper2 = [
    {
        imgSrc: '/images/top/contents/slide2/img1.jpg',
        subTitle: 'プログラム',
        title: 'クリスマスツリーハント in YOKOHAMA',
        titleBorder: true,
        content: '「Christmas Market in 横浜赤レンガ倉庫」との連携施策として、それぞれの会場のクリスマスツリーを写真に撮ってSNSに投稿すると、もう一方の会場で特典をゲットできるSNS投稿企画「クリスマスツリーハント in YOKOHAMA」を実施します。',
        link: [
            {
                url: 'https://www.yokohama-akarenga.jp/brickjournal/detail/171',
                text: '参加方法やもらえる特典についての情報など詳細はこちら',
                newTab: true
            }
        ]
    },
    {
        imgSrc: '/images/top/contents/slide2/img2.jpg',
        subTitle: 'プログラム',
        title: '2つのイベント会場限定デザイングッズも登場',
        titleBorder: true,
        content: [
            "「Christmas Market in 横浜赤レンガ倉庫」との連携施策として、BALLPARK Xmasのグッズショップ「BALLPARK Xmas SHOP」を横浜赤レンガ倉庫イベント会場内に出店予定です。ここで2つのイベント会場限定デザインの「Moominvalley's Winter Rose」シリーズ、オリジナルグッズを展開します。",
            '横浜公園と横浜赤レンガ倉庫、2つの開催地を象徴するブルーとレッドを基調としたデザインで、ブルーVerは横浜公園のGoods Areaにて、レッドVerは横浜赤レンガ倉庫の「BALLPARK Xmas SHOP」で販売予定です。',
            '2つの会場を巡りながら、横浜を舞台に「ムーミン」とのコラボレーションをお楽しみください。'
        ]
    }
];
export default defineComponent({
    setup: function () {
        return { dataSwiper1: dataSwiper1, dataSwiper2: dataSwiper2 };
    }
});
